/*    
<summary>
  This functional component "AddWorkingDaysPopupHOC" provides props to the child component.
  1. State "showAddWorkingDaysPopup" that manages the show/hide of pop up
  2. Function "AddWorkingDaysPopupToggleHandler" to toggle the show/hide popup state "showAddWorkingDaysPopup"
  Developer:Aashish Singh, Created Date:30-July-2025
</summary>
<returns>Returns JSX</returns>
*/

import React, {useState } from 'react';

const AddWorkingDaysPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showAddWorkingDaysPopup,setShowAddWorkingDaysPopup] = useState<boolean>(false);

    const addWorkingDaysToggleHandler = () => {
        setShowAddWorkingDaysPopup(!showAddWorkingDaysPopup);
    }
    
    return <Component showAddWorkingDaysPopup={showAddWorkingDaysPopup} addWorkingDaysPopupToggleHandler={addWorkingDaysToggleHandler} {...props}/>;
};

export default AddWorkingDaysPopupHOC;   